import { GiIsland } from "react-icons/gi";
import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Find Your Land Experience",
  name: "fyle",
  type: "object",
  icon: GiIsland,
  fields: [
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayString"
    }
  ],
  preview: {
    select: {
      title: "title"
    },
    prepare(selection) {
      const { title } = selection;
      const previewTitle = multilingualStringPreview(title);
      return {
        title: previewTitle || "(Find Your Land Experience)"
      };
    }
  }
});
